/** Minimal Markdown renderer for blog body. Supports ##/###, paragraphs, bullet lists, and bold. */
export function MarkdownBody({ source }: { source: string }) {
  const blocks = source.split(/\n{2,}/);
  return (
    <div className="max-w-none text-[15px] leading-7 text-foreground/80">
      {blocks.map((b, i) => {
        const trimmed = b.trim();
        if (/^### /.test(trimmed)) return <h3 key={i} className="text-[17px] font-semibold tracking-tight text-foreground mt-8 mb-2">{trimmed.replace(/^###\s+/, "")}</h3>;
        if (/^## /.test(trimmed)) return <h2 key={i} className="text-[22px] font-semibold tracking-tight text-foreground mt-10 mb-3">{trimmed.replace(/^##\s+/, "")}</h2>;
        if (/^# /.test(trimmed)) return <h2 key={i} className="text-[22px] font-semibold tracking-tight text-foreground mt-10 mb-3">{trimmed.replace(/^#\s+/, "")}</h2>;
        if (/^\s*[-*]\s+/m.test(trimmed)) {
          const items = trimmed.split(/\n/).map((l) => l.replace(/^\s*[-*]\s+/, ""));
          return (
            <ul key={i} className="list-disc pl-6 space-y-2 my-4">
              {items.map((it, j) => <li key={j} dangerouslySetInnerHTML={{ __html: bold(it) }} />)}
            </ul>
          );
        }
        return <p key={i} className="my-4" dangerouslySetInnerHTML={{ __html: bold(trimmed) }} />;
      })}
    </div>
  );
}

function escapeHtml(s: string) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

// Escape ALL HTML first, then re-introduce only the <strong> tag for **bold**.
// This prevents stored XSS from raw <script>/<img onerror=...> in article content.
function bold(s: string) {
  return escapeHtml(s).replace(/\*\*([^*]+)\*\*/g, "<strong class='text-foreground'>$1</strong>");
}
